module.exports = __webpack_public_path__ + "img/flutter.32ac5d46.png";